/* eslint-disable import/no-unresolved */
import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import Button from "@mui/material/Button";
import SubHeader from "../../../../components/SubHeader";
import PayrollModuleList from "./PayrollModuleList";
import styles from "./style";
import { useNavigate } from "react-router-dom";

const PayrollModulePage = ({ handleSearch, data, handleDelete, handlePayrollStatus, count, page, setPage, getPayrollList, permission, role }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isEmployeeRole = role === "Employee" || role === "employee";

  const handleFilter = (filter) => {
    handleSearch("", filter)
  }

  const handleSort = (sort) => {
    handleSearch("", "", sort)
  }

  return (
    <>
      <Box px="15px" pt="20px" display="flex" justifyContent="space-between" alignItems="center">
        <Typography sx={styles.leaveHeading}>{isEmployeeRole ? "My Payroll Module" : "Payroll Module"}</Typography>
        {permission || role === "Admin" ? <Button variant="contained" color="success" sx={styles.downloadbtn} onClick={() => { navigate("/dashboard/payrollModule/addPayroll") }}>
          Add Payroll
        </Button> : null}
      </Box>
      <Box sx={{ backgroundColor: theme.palette.white.main, m: 2, borderRadius: "20px" }} >
        <SubHeader title={isEmployeeRole ? "My Payroll" : "Employee Salary"}
          search={true}
          sortBy={true}
          onCompanyChange={getPayrollList}
          onchange={handleSearch}
          handleSort={handleSort}
          filter={handleFilter}
          isShowFilter={false}
        />
        <PayrollModuleList data={data} count={count} page={page} setPage={setPage} handleDelete={handleDelete} handlePayrollStatus={handlePayrollStatus} />
      </Box>
    </>
  );
};

export default PayrollModulePage;
